@if (titleRow(); as row) {
    <div class="row title-row">
        <label>{{ row.label }}</label>
        <label>{{ row.value }}</label>
    </div>
}
@for (row of rows(); track row.label) {
    <div class="row">
        <label>{{ row.label }}</label>
        <span>{{ row.value || '-' }}</span>
    </div>
}
